module.exports = __webpack_public_path__ + "static/img/200113.98d25da6.png";